import React from "react";
import { birthData, sailing } from "../../UTIL/localstorageauth/PagesData/Data";
import {
  Box,
  Text,
  Image,
  Button,
  SimpleGrid,
  VStack,
  HStack,
  Stack,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const Birthday = () => {
  return (
    <>
      {/* <HStack
        w="90%"
        justifyContent={"center"}
        gap={8}
        m={"auto"}
        p={5}
        data-aos="fade-up"
        // border={"1px solid yellow"}
        flexDirection={["column","column","column","row"]}
      >
        {birthData?.map((item) => (
          <Stack
            borderWidth="1px"
            borderRadius="lg"
            w={{ sm: "100%", md: "540px" }}
            height={{ sm: "476px", md: "20rem" }}
            direction={{ base: "column", md: "row" }}
            // boxShadow={"2xl"}
            padding={4}
          >
            <Flex flex={1} bg="blue.200">
              <Image
                objectFit="cover"
                boxSize="100%"
                src={item.img}
                alt={item.alt}
              />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={"2xl"} fontFamily={"body"}>
                {item.text}
              </Heading>
              <Text fontWeight={600} color={"gray.500"} size="sm" mb={4}>
                {item.start}
              </Text>
              <Text
                textAlign={"center"}
                px={3}
              >
                {item.desc}
              </Text>
              <Stack
                width={"100%"}
                mt={"2rem"}
                direction={"row"}
                padding={2}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Link to="/allpackages">
                  <Button
                    fontFamily="700"
                    fontSize={"18px"}
                    textTransform={"capitalize"}
                    flex={1}
                    backgroundColor={"#081839"}
                    color={"white"}
                    boxShadow={
                      "0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)"
                    }
                    _hover={{
                      backgroundColor: "#081839",
                    }}
                    _focus={{
                      backgroundColor: "#081839",
                    }}
                  >
                    Book package
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        ))}
      </HStack> */}

      <Box w="90%" mx="auto" mt="2rem" mb="10px">
        <SimpleGrid mt="2" columns={[1, 1, 2, 3]} spacing="40px" pb="5">
          {sailing.map((e, ind) => (
            <Text key={ind} as="span" data-aos="flip-right">
              <Box
                height="auto"
                boxShadow="rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px"
                borderRadius="10px"
                p="2"
              >
                <SimpleGrid columns={[2, 2, 2, 2]} spacing="2">
                  <Box h="240px">
                    <Image
                      borderRadius={"10px"}
                      src={e.imgurl}
                      alt="d"
                      w="100%"
                      h="100%"
                      _hover={{
                        WebkitTransform: "scale(0.8)",
                        transition: "1s ease",
                        transfrom: "scale(0.8)",
                        msTransform: "scale(0.8)",
                      }}
                    />
                  </Box>

                  <Box height={["240px", "240px", "240px"]} px="2">
                    <VStack
                      textAlign={"justify"}
                      h="100%"
                      alignItems={"flex-start"}
                      justifyContent={[
                        "center",
                        "space-between",
                        "space-between",
                      ]}
                      textTransform="capitalize"
                    >
                      <Text
                        letterSpacing={"2px"}
                        fontWeight="700"
                        fontSize={{ base: "18px", md: "18px", lg: "19px" }}
                        color="#000000"
                      >
                        {e.title}
                      </Text>
                      <Text
                        fontWeight="500"
                        fontSize={{ base: "14px", md: "12px", lg: "15px" }}
                        color="#000000"
                        textAlign={"justify"}
                        noOfLines="3"
                      >
                        {e.desc}
                      </Text>
                      <Text
                        fontWeight="500"
                        fontSize={{ base: "12px", md: "12px", lg: "15px" }}
                        color="#000000"
                        textAlign={"justify"}
                      >
                        Starts From Rs.{e.prise}
                      </Text>
                      <Link to="/allpackages">
                        <Button
                          w={{ base: "100%", md: "113px" }}
                          h="40px"
                          backgroundColor={"#081839"}
                          color="white"
                          _hover={{ backgroundColor: "#081839" }}
                          fontWeight={"700"}
                          fontSize={{ base: "14px", md: "16px", lg: "18px" }}
                          mt="20px"
                        >
                          Book Now
                        </Button>
                      </Link>
                    </VStack>
                  </Box>
                </SimpleGrid>
              </Box>
            </Text>
          ))}
        </SimpleGrid>
      </Box>
    </>
  );
};

export default Birthday;
